<template lang="pug">
    div  
        .card-body.bg-light
            .form-row
                .col-md-4
                    label Nombre
                    input.form-control.form-control-sm(v-model="parameter.NameUser", @keypress.enter="sendSearch()")
                .col-md-2
                    label 
                    button.btn.btn-primary.text-light.btn-block(@click="sendSearch()") Buscar 
                        i.fa.fa-search  
        .card-body.bg-light    
            .form-group
                    table.table.table-sm.table-borderedonlytable
                        thead.bg-table.text-white
                            th Editar
                            th Nombre
                            th Mensaje 
                            th Expresion
                            th Estado                        
                        tbody.bg-white(name="table-fade", is="transition-group") 
                            tr(v-if="",v-bind:key="index" v-for="(item,index) in tablaInfo")
                                td
                                    button.btn.btn-sm.btn-info(@click="sendInfo(item)")  
                                        i.fa.fa-edit 
                                td {{item.NameExpressionRegulate}} 
                                td {{item.ValidateMessage}} 
                                td {{item.ValidateExpressionRegulate}}
                                td {{item.Active==1 ? 'Activo':'Inactivo'}}

</template>
<script> 
export default {
    props:{
        tablaInfo:Array,
        parameter:Object
    }, 
    methods:{ 
            sendSearch(){ 
                this.$emit("update:parameter",this.parameter) 
                this.$emit("sendSearch",this.parameter) 
            },
            sendInfo(item){  
                this.$emit("sendInfo", Object.assign({}, item)) 
            }
    }
}
</script>
<style>
    .table-fade-enter-active {
      transition: all .5s ease;
    }
    .table-fade-leave-active {
      transition: all .5s ease;
    }
    .table-fade-enter, .table-fade-leave-to{
      transform: translateY(-20px);
      opacity: 0;
    } 
</style>